function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#ZipFolder_svg__clip0_1818_35584)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M20 6.552v10a2.069 2.069 0 01-2.069 2.069H2.069A2.069 2.069 0 010 16.55V1.38C0 .618.618 0 1.38 0h7.586c.761 0 1.379.618 1.379 1.38v.689h6.207c.762 0 1.379.618 1.379 1.38v1.034A2.072 2.072 0 0120 6.552z",
  fill: "#F0C419"
}), /*#__PURE__*/React.createElement("path", {
  d: "M17.931 3.448v1.035H0V1.379C0 .618.618 0 1.38 0h7.586c.761 0 1.379.618 1.379 1.38v.689h6.207c.762 0 1.379.618 1.379 1.38z",
  fill: "#F29C1F"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6.207 4.483h-1.38a.345.345 0 110-.69h1.38a.345.345 0 110 .69z",
  fill: "#E57E25"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10 14.138a.345.345 0 01-.345-.345v-9.31a.345.345 0 01.69 0v9.31c0 .19-.155.345-.345.345z",
  fill: "#547580"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.966 6.207H8.62a.345.345 0 110-.69h.345a.345.345 0 110 .69zM8.966 7.586H8.62a.345.345 0 110-.69h.345a.345.345 0 110 .69zM8.966 8.966H8.62a.345.345 0 110-.69h.345a.345.345 0 110 .69zM8.966 10.345H8.62a.345.345 0 110-.69h.345a.345.345 0 110 .69zM8.966 11.725H8.62a.345.345 0 110-.69h.345a.345.345 0 110 .69zM8.966 13.104H8.62a.345.345 0 110-.69h.345a.345.345 0 110 .69zM11.38 6.897h-.345a.345.345 0 110-.69h.345a.345.345 0 010 .69zM11.38 8.277h-.345a.345.345 0 110-.69h.345a.345.345 0 010 .69zM11.38 9.655h-.345a.345.345 0 110-.69h.345a.345.345 0 010 .69zM11.38 11.034h-.345a.345.345 0 110-.69h.345a.345.345 0 010 .69zM11.38 12.414h-.345a.345.345 0 110-.69h.345a.345.345 0 010 .69zM11.035 15.862l1.326 3.183a.69.69 0 01-.637.955H8.276a.69.69 0 01-.637-.955l1.327-3.183h2.069z",
  fill: "#7F8C8D"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.345 18.965h-.69a.345.345 0 110-.69h.69a.345.345 0 110 .69z",
  fill: "#547580"
}), /*#__PURE__*/React.createElement("path", {
  d: "M17.931 3.793v.69h-10a.345.345 0 110-.69h10z",
  fill: "#E57E25"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.034 13.793H8.965a.345.345 0 00-.344.345v1.38c0 .19.154.344.344.344h2.07c.19 0 .344-.155.344-.345v-1.38a.345.345 0 00-.345-.344z",
  fill: "#95A5A5"
}));

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "ZipFolder_svg__clip0_1818_35584"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h20v20H0z"
})));

function SvgZipFolder(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2);
}

export default SvgZipFolder;